var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-64, -320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-image",
    transform: "translate(64, 320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,4.5 C11.5522847,4.5 12,4.94771525 12,5.5 L12,10.5 C12,11.0522847 11.5522847,11.5 11,11.5 L5,11.5 C4.44771525,11.5 4,11.0522847 4,10.5 L4,5.5 C4,4.94771525 4.44771525,4.5 5,4.5 L11,4.5 Z M8.87945227,7.67973353 C8.86058643,7.69231076 8.84399665,7.70800446 8.83039231,7.72614359 L7.63836116,9.31551845 C7.57208699,9.40388401 7.44672672,9.42179262 7.35836116,9.35551845 C7.35079014,9.34984018 7.3436317,9.3436317 7.3369398,9.3369398 L6.6630602,8.6630602 C6.58495534,8.58495534 6.45832234,8.58495534 6.38021748,8.6630602 C6.37352558,8.66975209 6.3673171,8.67691053 6.36163884,8.68448155 L5.24,10.18 C5.17372583,10.2683656 5.19163444,10.3937258 5.28,10.46 C5.31461924,10.4859644 5.35672596,10.5 5.40000001,10.5 L10.6262966,10.5 C10.7367535,10.5 10.8262966,10.4104569 10.8262966,10.3 C10.8262966,10.260515 10.814609,10.2219135 10.7927066,10.18906 L9.15680237,7.73520355 C9.09553188,7.64329781 8.97135801,7.61846304 8.87945227,7.67973353 Z M6,5.5 C5.44771525,5.5 5,5.94771525 5,6.5 C5,7.05228475 5.44771525,7.5 6,7.5 C6.55228475,7.5 7,7.05228475 7,6.5 C7,5.94771525 6.55228475,5.5 6,5.5 Z",
    id: "Combined-Shape",
    fill: "#0078DB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeInfo);
export default __webpack_public_path__ + "static/media/trade-info.c4e36deb0b3940472fbcbfd324cf5817.svg";
export { ForwardRef as ReactComponent };